<template>
  <div class="dashboard_container page_content superAdmin_dashboard" aria-label="Super Admin Dashboard Page Content">
    <div class="col-12 dashboard-content-section">
      <div class="row dashboard-row">
        <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="card ace_sec" aria-label="Insights Across Institutions">
            <div class="card-header">
              <span class="icon float-left icon-reports text-center mr-2"></span>
              <span class="label ace_sec_hd" role="heading" aria-level="1">Insights Across Institutions</span>
            </div>
            <div class="card-body">
              <div class="coming_soon">coming soon</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="card ace_sec" aria-label="Urgent Notifications">
            <div class="card-header">
              <span class="icon icon-bell float-left icon-course text-center mr-2"></span>
              <span class="label ace_sec_hd" role="heading" aria-level="1">Urgent Notifications</span>
            </div>
            <div class="card-body">
              <div class="coming_soon">coming soon</div>
            </div>
          </div>
        </b-col>
      </div>
      <div class="row dashboard-row">
        <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="card ace_sec" aria-label="Entities">
            <div class="card-header">
              <span class="icon float-left ico-entity text-center mr-2"></span>
              <span class="label ace_sec_hd" role="heading" aria-level="1">Entities</span>
            </div>
            <div class="card-body">
              <div @click="institutionsClicked" class="col-xl-5 col-lg-5 col-md-10 col-sm-10 inst_entt_box float-left">
                <div class="inst_entt_box_content">
                  <div class="thumbnail">
                    <span class="ico-buildingCollege icon"></span>
                  </div>
                  <div class="title-row">
                    <span tabindex="0" class="title">Institutions</span>
                  </div>
                </div>
              </div>
              <div @click="preCuratedInstitutionsClicked" class="col-xl-5 col-lg-5 col-md-10 col-sm-10 inst_entt_box float-right">
                <div class="inst_entt_box_content">
                  <div class="thumbnail">
                    <span class="ico-buildingCollege icon"></span>
                  </div>
                  <div class="title-row">
                    <span tabindex="0" class="title">Pre-Curated Institutions</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="card ace_sec" aria-label="Employers">
            <div class="card-header">
              <span class="icon float-left ico-employer text-center mr-2"></span>
              <span class="label ace_sec_hd" role="heading" aria-level="1">Employers</span>
            </div>
            <div class="card-body">
              <div @click="employersClicked" class="col-xl-5 col-lg-5 col-md-10 col-sm-10 inst_entt_box float-left" role="link" tabindex="0" @keydown.enter="employersClicked">
                <div class="inst_entt_box_content">
                  <div class="thumbnail">
                    <span class="ico-employer icon"></span>
                  </div>
                  <div class="title-row">
                    <span class="title">Employers</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'superAdminDashboard',
    props: [],
    data: () => {
      return {
        page: 0,
        courses: [],
        lastPage: false,
        superAdminPermissionName: 'SUPERADMIN_PERMISSION',
        knockoutDashboardHome: '/dashboard/views/myHome.html'
      }
    },

    mounted () {
      if (!this.isSuperAdmin) {
        this.redirectToKnockoutDashboard()
        return
      }
      this.loadPackages()
    },

    methods: {
      ...mapActions([
        'loadPackages'
      ]),
      institutionsClicked () {
        return this.$router.push({ name: 'institutionList' })
      },
      preCuratedInstitutionsClicked () {
        return this.$router.push({ name: 'preCuratedInstitutionList' })
      },
      employersClicked () {
        return this.$router.push({ name: 'employerUpload' })
      },
      redirectToKnockoutDashboard () {
        window.location.href = this.knockoutDashboardHome
      }
    },

    computed: {
      ...mapState({
        'permission': state => state.user.permission,
        'userRole': state => state.user.userRole,
        'userObject': state => state.user.userObj
      }),

      isSuperAdmin () {
        let userObject = JSON.parse(localStorage.getItem('userobj'))
        let permission = userObject.permission || this.permission
        return permission.name === this.superAdminPermissionName
      }
    }
  }
</script>

<style scoped>
.next {
  margin-top: 10%;
}

.icon-master {
  float: right !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
}

.slide-leave-active, .slide-enter-active {
  transition: 1s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}

.img-slider {
  overflow: hidden;
  position: relative;
  height: 200px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/SuperAdminDashboard.vue